import React from "react";

const BongkarMuat = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Bongkar Muat"
        src="https://lookerstudio.google.com/embed/reporting/94b88bfa-24a6-48ac-ac63-c50f58cd7a49/page/IXd9D"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default BongkarMuat;
